import { elaAppProxy, elaAppProxyBody } from './index';
// proxy/ela/app/
// proxyBody/ela/app/

/* [ 모든문서 ] */
// 내문서함 목록조회
function getMyBoxList(params) {
  return elaAppProxy.get('1.0/mybox/list', { params });
}

// 결재할문서 목록조회
function getApprDocList(params) {
  return elaAppProxy.get('1.0/appr/list', { params });
}

// 참조함
function getReferBox(params) {
  return elaAppProxy.get('1.0/referbox/list', { params });
}

// 결재할문서 결재
function postApplConfirm(params) {
  return elaAppProxyBody.post('1.0/appl/confirm', params);
}

export { getMyBoxList, getApprDocList, postApplConfirm, getReferBox };
